import { render } from "./SimpleModal.vue?vue&type=template&id=a9718b14&ts=true"
import script from "./SimpleModal.vue?vue&type=script&lang=ts"
export * from "./SimpleModal.vue?vue&type=script&lang=ts"

import "./SimpleModal.vue?vue&type=style&index=0&id=a9718b14&lang=scss"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__